<!--
재고입고(등록) 에서 사용되는 필드셋 패널
-->
<template>
    <fieldset class="uk-fieldset">
        <legend class="uk-legend">{{ title }}</legend>
        <div class="box" >
            <slot>EMPTY</slot>
        </div>
    </fieldset>        
</template>

<script>
    export default {
        props: {
            /**
             * 제목
             */
            title: {
                type: String,
                default: '',
            }
        }
    }
</script>

<style lang="scss" scoped>
    fieldset.uk-fieldset legend.uk-legend {
        font-size: 1rem;
        color: #999;
        margin-bottom: 5px;
        text-align: right;
    }
    .box {
        //box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        padding-top: 10px;
        border-top: 1px solid #aaa;
    }
</style>